/**CORE LIBRARIES IMPORT */
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

/**HOOKS / DATA IMPORT */
import useInViewOnce from "../hooks/useInViewOnce";
import { BOOK_TABLE_PATH } from "../data/navigation";

const MotionLink = motion.create(Link);

/** Centered call-to-action band with the template's hero light sweep. */
const BookingCta = () => {
  const [h2Ref, inView] = useInViewOnce(0.5);

  return (
    <section className="booking-cta" aria-labelledby="booking-cta-heading">
      <motion.div
        className="light-sweep"
        aria-hidden="true"
        animate={{ x: ["-100%", "100%"] }}
        transition={{ repeat: Infinity, duration: 6, ease: "linear" }}
      />
      <div className="booking-cta-inner">
        <h2 id="booking-cta-heading" ref={h2Ref} className={`section-heading ${inView ? "in-view" : ""}`}>
          Book a Table
        </h2>
        <motion.p
          className="section-text"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          Send us your preferred date, time and party size and we will reply by
          email to confirm your table.
        </motion.p>
        <div className="hero-buttons section-buttons">
          <MotionLink to={BOOK_TABLE_PATH} className="hero-btn" whileHover={{ y: -6, scale: 1.05 }} whileTap={{ scale: 0.96 }}>
            Book a Table
          </MotionLink>
          <MotionLink to="/book?type=private" className="hero-btn" whileHover={{ y: -6, scale: 1.05 }} whileTap={{ scale: 0.96 }}>
            Event Enquiry
          </MotionLink>
        </div>
      </div>
    </section>
  );
};

export default BookingCta;
